export var Otosco = [
    {
        id:42,
        img:require("../../Images/Otoscope1.webp"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"350 EGP"
    },
    {
        id:43,
        img:require("../../Images/Otoscope2.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"450 EGP"
    },
    {
        id:44,
        img:require("../../Images/Otoscope3.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"250 EGP"
    },
    {
        id:45,

        img:require("../../Images/Otoscope4.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"2500"
    },
    {
        id:46,

        img:require("../../Images/Otoscope5.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1500"
    },
    {
        id:47,

        img:require("../../Images/Otoscope6.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1300"
    },
    {
        id:48,

        img:require("../../Images/Otoscope7.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"900"
    },
    {
        id:49,

        img:require("../../Images/Otoscope8.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1200"
    },
    {
        id:50,

        img:require("../../Images/Otoscope9.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1250"
    },
    {
        id:51,

        img:require("../../Images/Otoscope10.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1400"
    },
    {
        id:52,

        img:require("../../Images/Otoscope11.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1350"
    },
    {
        id:53,

        img:require("../../Images/Otoscope12.jpg"),
        title:"Otoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1550"
    },



]